import { Flex, Popover } from "antd";
import moment from "moment";
import {
  ANALYSIS_TYPE_VIDEO_CLIP,
  ANALYSIS_TYPE_NOTES,
  ANALYSIS_TYPE_BOOKMARKS,
  ANALYSIS_TYPE_ANNOTATIONS,
  ANALYSIS_TYPE_TRANSCRIPTS,
  ANALYSIS_TYPE_BOOKMARKS_TEXT,
  ANALYSIS_TYPE_NOTES_TEXT,
  ANALYSIS_TYPE_TRANSCRIPTS_TEXT,
  ANALYSIS_TYPE_TRANSLATION,
  ANALYSIS_TYPE_TRANSLATION_TEXT,
  ANALYSIS_TYPE_ANNOTATIONS_TEXT,
  ANALYSIS_TYPE_VIDEO_CLIP_TEXT,
} from "../../actions/constants";
import TagPill from "../manage-tags/TagPill";

export const getAnalysisType = (type) => {
  return type === ANALYSIS_TYPE_VIDEO_CLIP
    ? ANALYSIS_TYPE_VIDEO_CLIP_TEXT
    : type === ANALYSIS_TYPE_NOTES
      ? ANALYSIS_TYPE_NOTES_TEXT
      : type === ANALYSIS_TYPE_BOOKMARKS
        ? ANALYSIS_TYPE_BOOKMARKS_TEXT
        : type === ANALYSIS_TYPE_ANNOTATIONS
          ? ANALYSIS_TYPE_ANNOTATIONS_TEXT
          : type === ANALYSIS_TYPE_TRANSCRIPTS
            ? ANALYSIS_TYPE_TRANSCRIPTS_TEXT
            : type === ANALYSIS_TYPE_TRANSLATION
              ? ANALYSIS_TYPE_TRANSLATION_TEXT
              : "";
};

export const getTagNames = (apiData, tags) => {
  let tagNames = [];
  if (tags) {
    tags.forEach((tag) => {
      const tg = apiData?.tags?.find((t) => Number(t.id) === Number(tag));
      if (tg) tagNames.push(tg?.tag);
    });
  }
  return tagNames.join(", ");
};

export const capitalize = (str) => {
  const lower = str.toLowerCase();
  return str.charAt(0).toUpperCase() + lower.slice(1);
};

export const getUniqueModifiedUsers = (ranges) => {
  let m = [];
  ranges.forEach((r) => {
    const fname = r.modified_user.trim().split(" ")[0];
    if (m.indexOf(fname) === -1) m.push(fname);
  });
  return m.join(", ");
};

export const getUniqueModifiedBy = (ranges) => {
  let m = [];
  ranges.forEach((r) => {
    if (m.indexOf(r.modified_by.trim()) === -1) m.push(r.modified_by.trim());
  });
  return m.join(", ");
};

export const getRefererUrl = (apiData) => {
  let backTo = "";
  if (apiData?.referrer) backTo = apiData?.referrer;
  else if (document.referrer) {
    backTo = document.referrer;
    if (window.location.href === document.referrer) {
      backTo = apiData?.reportBaseUrl;
    }
  } else backTo = apiData?.reportBaseUrl;

  return backTo;
};

export const goBack = (projectId, apiData, turorialType = null) => {
  let backTo = getRefererUrl(apiData);
  const url = new URL(backTo);
  url.searchParams.delete("analysis_tutorial");
  url.searchParams.delete("analysis_test");
  if (turorialType != null) {
    url.searchParams.append("analysis_tutorial", turorialType);
    url.searchParams.append("analysis_test", projectId);
  }
  backTo = url.toString().replace("%2F", "");

  window.location = backTo;
};

export const formatDuration = (seconds) =>
  seconds ? new Date(seconds * 1000).toISOString().slice(seconds >= 3600 ? 11 : 14, 19) : "00:00";

export const formatDurationHMS = (seconds) => {
  let d = formatDuration(seconds);
  if (d.split(":").length === 2) d = "0:" + d;
  return d;
};

export const showMeHow = (projectId, apiData, type) => {
  goBack(projectId, apiData, type);
};

export const sortRanges = (a, b) => {
  if (parseInt(a.begin) > parseInt(b.begin)) return 1;
  if (parseInt(a.begin) < parseInt(b.begin)) return -1;
  return parseInt(a.end) - parseInt(b.end);
};

export const hexToRgbA = (hex, alpha = 1) => {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + "," + alpha + ")";
  }
  throw new Error("Bad Hex");
};

export const createHighlightedString = (apiData, ranges, txt) => {
  if (!txt || !ranges) return { __html: "" };
  if (txt === "") return { __html: "" };
  if (txt && ranges && !ranges.length) return { __html: txt.replaceAll("&nbsp;", " ") };

  txt = txt.trim();

  ranges.forEach((r) => {
    if (parseInt(r.begin) > parseInt(r.end)) {
      let t = r.begin;
      r.begin = r.end;
      r.end = t;
    }
  });

  ranges.sort(sortRanges);

  let whileCond = true;
  while (whileCond) {
    let intersectedRanges = [];
    let swappingHappened = false;
    for (let i = 0; i < ranges.length; i++) {
      let begin = ranges[i].begin;
      let end = ranges[i].end;
      let doNotPush = false;

      if (ranges[i - 1] !== undefined && ranges[i].begin <= ranges[i - 1].end) {
        if (ranges[i - 1] !== undefined && ranges[i].end <= ranges[i - 1].end) {
          doNotPush = true;
        } else {
          begin = ranges[i - 1].end + 1;
        }

        swappingHappened = true;
      }

      !doNotPush && intersectedRanges.push({ ...ranges[i], begin, end });
    }
    ranges = intersectedRanges;
    whileCond = swappingHappened;
  }

  let blocks = [];

  if (Number(ranges[0].begin) !== 0) {
    const prevT = txt.slice(0, parseInt(ranges[0].begin));
    blocks.push(prevT);
  }

  for (let i = 0; i < ranges.length; i++) {
    const r = ranges[i];
    const nextR = ranges[i + 1];

    const t = parseInt(r.begin) !== parseInt(r.end) ? txt.slice(parseInt(r.begin), parseInt(r.end)) : txt.charAt(parseInt(r.begin));
    const tag = r.tags.split(",")[0];
    const firstTag = apiData.tags.find((t) => Number(t.id) === Number(tag));
    const mark = `<mark class='analysis-highlighted-mark' data-analysis-id='${r.id}' data-analysis-tags='${
      r.tags
    }' style='background-color:${hexToRgbA(firstTag?.color ? firstTag?.color : "#FFFFFF", 0.4)}'>${t}</mark>`;
    blocks.push(mark);

    if (nextR !== undefined) {
      const nextT = txt.slice(parseInt(r.end), parseInt(nextR.begin));
      blocks.push(nextT);
    }
  }

  if (parseInt(ranges[ranges.length - 1].end) !== txt.length) {
    const lastT = txt.slice(parseInt(ranges[ranges.length - 1].end), txt.length);
    blocks.push(lastT);
  }

  return { __html: blocks.join("").replaceAll("&nbsp;", " ") };
};

export const formatTotalDuration = (seconds) => {
  const hoursLeft = Math.floor(seconds / 3600);
  const min = Math.floor((seconds - hoursLeft * 3600) / 60);
  let secondsLeft = seconds - hoursLeft * 3600 - min * 60;
  secondsLeft = Math.round(secondsLeft * 100) / 100;
  let fTime = "";
  if (hoursLeft > 0) fTime += hoursLeft + "h ";
  if (min > 0) fTime += min + "m ";
  if (secondsLeft > 0) fTime += secondsLeft + "s ";
  return fTime;
};

export const getUniqueTagsForMarkup = (ranges) => {
  if (!ranges) return [];

  let uniqueTags = [];
  ranges?.forEach((range) => {
    range?.tags?.split(",").forEach((tag) => {
      if (uniqueTags?.indexOf(tag) === -1) uniqueTags?.push(tag);
    });
  });
  return uniqueTags;
};

export const goToSource = (logId, apiData, sessionId, refId, refType, translationLang, openInNewTab = false) => {
  let url = "";

  if (apiData?.isModeratedTest) {
    // Moderated test
    url = `${apiData?.reportBaseUrl}/videoplayer/${sessionId}?refId=${refId}&refType=${refType}`;
  } else {
    // Unmoderated test — the player path is always log_<log id> (every item type); session_id is only the
    // fallback when an item has no log id. The prefix keeps VideoPlayerProvider from reading a raw user_id.
    url = `${apiData?.videoPlayerBaseUrl}log_${Number(logId) || sessionId}?refId=${refId}&refType=${refType}`;
  }

  url += `&logId=${logId}`;

  if (refType === ANALYSIS_TYPE_TRANSLATION && translationLang) {
    url += `&translationLang=${translationLang}&sessionId=${sessionId}`;
  }

  if (openInNewTab) {
    window.open(url, "_blank", "noopener,noreferrer");
  } else {
    window.location = url;
  }
};

export const RenderUser = ({ data, parsedData: pd, analysisMode }) => {
  const parsed = pd ?? JSON.parse(data);
  return (
    <span className={`capitalize ${analysisMode ? "text-gray-17" : "color-2525e2c9"}`}>
      {" "}
      {parsed.user_name ? parsed.user_name : parsed.user_type}
    </span>
  );
};

export const RenderTags = ({ apiData, analysisMode, ranges, showLimited = false }) => {
  const items = getUniqueTagsForMarkup(ranges) || [];
  const showItems = showLimited ? items?.slice(0, showLimited) : items;
  const remainingItems = showLimited ? items?.slice(showLimited) : [];

  return (
    <div className='d-flex flex-wrap gap-5px align-items-center'>
      {showItems.map((tag) => {
        const item = apiData.tags.find((t) => Number(t.id) === Number(tag));
        return item ? <TagPill key={item.id} tag={item} size='small' /> : null;
      })}

      {remainingItems.length > 0 && (
        <Popover
          placement='bottomLeft'
          content={
            <Flex vertical gap={5}>
              {remainingItems.map((tag) => {
                const item = apiData.tags.find((t) => Number(t.id) === Number(tag));
                return item ? <TagPill key={item.id} tag={item} size='small' /> : null;
              })}
            </Flex>
          }
        >
          <span className='border-radius-4px font-size-11px'>+{remainingItems.length} more</span>
        </Popover>
      )}
    </div>
  );
};

export const RenderClipTags = ({ apiData, analysisMode, data, showLimited = false }) => {
  const items = JSON.parse(data).tags?.split(",") || [];
  const showItems = showLimited ? items?.slice(0, showLimited) : items;
  const remainingItems = showLimited ? items?.slice(showLimited) : [];

  return (
    <div className='d-flex flex-wrap gap-5px align-items-center'>
      {showItems.map((tag) => {
        const item = apiData.tags.find((t) => Number(t.id) === Number(tag));
        return item ? <TagPill key={item.id} tag={item} size='small' /> : null;
      })}

      {remainingItems.length > 0 && (
        <Popover
          placement='bottomLeft'
          content={
            <Flex vertical gap={5}>
              {remainingItems.map((tag) => {
                const item = apiData.tags.find((t) => Number(t.id) === Number(tag));
                return item ? <TagPill key={item.id} tag={item} size='small' /> : null;
              })}
            </Flex>
          }
        >
          <span className='border-radius-4px font-size-11px'>+{remainingItems.length} more</span>
        </Popover>
      )}
    </div>
  );
};

export const getSpacesForInsight = (insights, renderingData, insightId) => {
  const insight = insights.find((item) => Number(item.id) === Number(insightId));
  let spaces = [];
  if (insight?.space_ids) {
    const space_ids = insight?.space_ids?.split(",");
    space_ids?.forEach((space_id) => {
      const space = renderingData.find((item) => {
        return (
          (item.type === ANALYSIS_TYPE_VIDEO_CLIP && Number(item.id) === Number(space_id)) ||
          (item.type !== ANALYSIS_TYPE_VIDEO_CLIP && item.ranges.some((r) => Number(r.id) === Number(space_id)))
        );
      });
      if (space) spaces.push(space);
    });
  }
  return spaces;
};

export const numberToColumnLetter = (num) => {
  let result = "";
  while (num > 0) {
    const remainder = (num - 1) % 26;
    result = String.fromCharCode(65 + remainder) + result;
    num = Math.floor((num - 1) / 26);
  }
  return result;
};

export const showCommentTime = (time) => {
  const editedTime = moment.utc(time).local();
  const now = moment();

  const diffInMinutes = now.diff(editedTime, "minutes");
  let displayTime;

  if (diffInMinutes < 1) {
    displayTime = "now";
  } else if (diffInMinutes <= 60) {
    displayTime = editedTime.fromNow(); // e.g., "10 minutes ago"
  } else {
    if (editedTime.isSame(now, "day")) {
      // Same day: e.g., "7:45 AM Today"
      displayTime = `${editedTime.format("h:mm A")} Today`;
    } else if (editedTime.isSame(now, "year")) {
      // Same year but not today: e.g., "2 Jul, 10:51 PM"
      displayTime = editedTime.format("D MMM, h:mm A");
    } else {
      // Different year: e.g., "2 Jul 2024, 10:41 PM"
      displayTime = editedTime.format("D MMM YYYY, h:mm A");
    }
  }

  return displayTime;
};

const hexToHsl = (H) => {
  let r = parseInt(H.substring(1, 3), 16) / 255;
  let g = parseInt(H.substring(3, 5), 16) / 255;
  let b = parseInt(H.substring(5, 7), 16) / 255;

  const cmin = Math.min(r, g, b),
    cmax = Math.max(r, g, b),
    delta = cmax - cmin;

  let h = 0,
    s = 0,
    l = (cmax + cmin) / 2;

  if (delta !== 0) {
    if (cmax === r) h = ((g - b) / delta) % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
  }

  h = Math.round(h * 60);
  if (h < 0) h += 360;

  s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
  return { h, s, l };
};

const hslToHex = (h, s, l) => {
  l = Math.min(1, Math.max(0, l));
  s = Math.min(1, Math.max(0, s));

  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;
  let r = 0,
    g = 0,
    b = 0;

  if (0 <= h && h < 60) {
    r = c;
    g = x;
    b = 0;
  } else if (60 <= h && h < 120) {
    r = x;
    g = c;
    b = 0;
  } else if (120 <= h && h < 180) {
    r = 0;
    g = c;
    b = x;
  } else if (180 <= h && h < 240) {
    r = 0;
    g = x;
    b = c;
  } else if (240 <= h && h < 300) {
    r = x;
    g = 0;
    b = c;
  } else {
    r = c;
    g = 0;
    b = x;
  }

  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
};

export const getStrokeAndText = (fillHex) => {
  const { h, s, l } = hexToHsl(fillHex);

  // Slightly more precise offsets
  const stroke = hslToHex(h, s, l - 0.092);
  const text = hslToHex(h, s * 0.95, l - 0.752);

  return { stroke, text };
};

export const getErrMsg = (err) => {
  if (!err) return "Some error occurred";

  const resp = err.response?.data;
  if (typeof resp === "string") return resp;
  if (resp?.message) return resp.message;
  if (resp?.msg) return resp.msg;
  if (err.message) return err.message;

  try {
    return JSON.stringify(resp || err);
  } catch {
    return String(err);
  }
};

export const animateBorder = (el) => {
  if (!el) return;

  const color = "#EEFBF4";
  const t = 1000;

  // Add class before animation
  el.classList.add("animate-border");

  const anim = el.animate([{ backgroundColor: "#ffffff" }, { backgroundColor: color }, { backgroundColor: "#ffffff" }], {
    duration: t * 10, // total duration
    iterations: 1,
  });

  // Remove class after animation ends
  anim.onfinish = () => {
    el.classList.remove("animate-border");
  };
};

// --- space normalizer (yours, kept as-is) ---
const normalizeHtmlSpaces = (s) => {
  if (typeof s !== "string" || s === "") return s;

  // Strip BOM/zero-widths: FEFF (BOM/ZWNBSP), 200B (ZWSP), 2060 (WORD JOINER)
  const STRIP_RE = /[\uFEFF\u200B\u2060]/g;

  return (
    s
      .replace(STRIP_RE, "")
      // Entities → NBSP
      .replace(/&nbsp;|&#160;|&#xA0;/gi, "\u00A0")
      // NBSP → normal space (remove this line if you want to preserve NBSP)
      .replace(/\u00A0/g, " ")
      .trim()
  );
};

// --- CSS style declaration normalizer ---
const normalizeStyleString = (css) => {
  if (!css || typeof css !== "string") return "";

  // split; handle trailing semicolons; filter empties
  const parts = css
    .split(";")
    .map((p) => p.trim())
    .filter(Boolean);

  // parse "prop: value" pairs
  const kv = [];
  for (const p of parts) {
    const idx = p.indexOf(":");
    if (idx === -1) continue;
    let prop = p.slice(0, idx).trim().toLowerCase();
    let val = p.slice(idx + 1).trim();

    // normalize rgb()/rgba() spacing: "rgb(30, 58, 138)" -> "rgb(30,58,138)"
    val = val.replace(/\brgba?\s*\(\s*([^)]*)\)/gi, (_, inner) => {
      const compact = inner
        .split(",")
        .map((x) => x.trim())
        .join(",");
      const fn = _.toLowerCase().startsWith("rgba") ? "rgba" : "rgb";
      return `${fn}(${compact})`;
    });

    // collapse inner whitespace around punctuation
    val = val
      .replace(/\s*([,:/()])\s*/g, "$1")
      .replace(/\s{2,}/g, " ")
      .trim();

    kv.push([prop, val]);
  }

  // sort by property name for stable order
  kv.sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0));

  // rebuild; omit if empty
  return kv.length ? kv.map(([k, v]) => `${k}: ${v}`).join("; ") : "";
};

// --- apply to every style="..." or style='...' in the HTML string ---
const normalizeInlineStyles = (html) => {
  if (typeof html !== "string") return html;

  // double-quoted styles
  html = html.replace(/style\s*=\s*"([^"]*)"/gi, (_, css) => {
    const norm = normalizeStyleString(css);
    return norm ? `style="${norm}"` : "";
  });

  // single-quoted styles
  html = html.replace(/style\s*=\s*'([^']*)'/gi, (_, css) => {
    const norm = normalizeStyleString(css);
    return norm ? `style="${norm}"` : ""; // rewrite to double quotes for stability
  });

  return html;
};

// --- one-shot HTML canonicalizer for equality checks ---
export const normalizeHtmlForEquality = (html) => {
  if (typeof html !== "string") return html;
  // order matters: first unify spaces, then canonicalize styles
  const spaced = normalizeHtmlSpaces(html);
  return normalizeInlineStyles(spaced);
};

// Normalize "#abc" -> "#aabbcc", "#AABBCC" -> "#aabbcc"
export const normalizeHex = (hex) => {
  if (!hex) return "";
  let s = String(hex).trim().toLowerCase();
  if (!s.startsWith("#")) return s;
  if (s.length === 4) s = "#" + s[1] + s[1] + s[2] + s[2] + s[3] + s[3];
  if (s.length === 7) return s;
  return s; // unexpected -> return as-is
};

// Convert "rgb(a, b, c)" or "rgba(a, b, c, a)" -> "#rrggbb"
export const rgbToHex = (rgb) => {
  if (!rgb) return "";
  const m = String(rgb)
    .trim()
    .match(/^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (!m) return "";
  const r = (+m[1]).toString(16).padStart(2, "0");
  const g = (+m[2]).toString(16).padStart(2, "0");
  const b = (+m[3]).toString(16).padStart(2, "0");
  return `#${r}${g}${b}`;
};

// Accept hex/rgb/rgba/empty and return normalized hex or ""
export const normalizeColor = (val) => {
  if (!val) return "";
  const s = String(val).trim();
  if (s.startsWith("#")) return normalizeHex(s);
  if (/^rgba?\s*\(/i.test(s)) return rgbToHex(s);
  if (s.toLowerCase() === "transparent") return ""; // treat as none
  return s; // any other named color: return as-is (or map if you use any)
};
